/* eslint-disable no-unused-expressions */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-console */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-nested-ternary */
import { studies, metadata } from '@ohif/core';
import { parsePatientFromStudy, fetchAllPatientMetadata, loadRemainingSeries, updateStudyDisplaySets, updateStudyMetadataManager } from '../../../util/studiesManager';
import store from '../../../store/store';
import { setPatient, addStudy, setMainStudyId } from '../../../actions/PatientActions';
import { displayFirstSeries } from './ViewerRoot';

export const findEarliest = (studiesToFindEarliest) => studiesToFindEarliest.reduce((prev, curr) => (prev.StudyDate > curr.StudyDate ? prev : curr));

export const findEarliestOfTwo = (studiesToFindEarliest) => {
  console.log('*** studiesToFindEarliest', studiesToFindEarliest);
  console.log('*** studiesToFindEarliest - ', typeof studiesToFindEarliest, studiesToFindEarliest.length);

  // if (studiesToFindEarliest.length <= 0) return;

  return studiesToFindEarliest.reduce((prev, curr) =>
    prev.study.StudyDate === curr.study.StudyDate && prev.study.StudyDate === curr.study.StudyDate ? (prev.study.StudyTime > curr.study.StudyTime ? prev : curr) : prev.study.StudyDate > curr.study.StudyDate ? prev : curr
  );
};

let cancelCallback = [];

export const SearchByPatientId = async ({ PatientId, availableServers, setFetchComplete, setRenderViewer, setError }) => {
  console.log('*** search by patient id');
  let earliestStudy;
  let promises = [];

  const fetchHistoryPromise = ({ pServer }) =>
    new Promise(async (resolve) => {
      let foundStudiesByPatient = {};
      let finished;

      cancelCallback.push(() => {
        if (!finished) {
          // canceled = true;
          resolve(false);
        }
      });

      try {
        const studyMetadata = await studies.searchStudies(pServer, { PatientID: PatientId });
        foundStudiesByPatient[pServer.qidoRoot] = { study: findEarliest(studyMetadata), server: pServer }; //  study: findEarliest(studyMetadata)
      } catch (err) {
        console.log('*** no patient history found');
        resolve(false);
      }

      const studiesFound = Object.values(foundStudiesByPatient);

      const mostRecent = findEarliestOfTwo(studiesFound);
      // if (!mostRecent) return;
      const earliestStudyKey = Object.keys(foundStudiesByPatient).find(
        (key) => foundStudiesByPatient[key].study.StudyDate === mostRecent.study.StudyDate && foundStudiesByPatient[key].study.StudyTime === mostRecent.study.StudyTime
      );
      const { AccessionNumber, StudyInstanceUID, StudyDate } = foundStudiesByPatient[earliestStudyKey].study;
      const { server } = foundStudiesByPatient[earliestStudyKey];

      try {
        studies.deleteStudyMetadataPromise(StudyInstanceUID);
        earliestStudy = await studies.retrieveStudyMetadata(server, StudyInstanceUID, { AccessionNumber, StudyDate });
      } catch (err) {
        console.error('*** no study data via studyInstanceUID at: ', server.qidoRoot);
      }
      earliestStudy = { ...earliestStudy, server: pServer };

      const patient = parsePatientFromStudy(earliestStudy);
      store.dispatch(setPatient(patient));
      store.dispatch(addStudy(earliestStudy));
      store.dispatch(setMainStudyId(earliestStudy.StudyInstanceUID));
      earliestStudy && earliestStudy.StudyInstanceUID && displayFirstSeries(earliestStudy, earliestStudy.StudyInstanceUID);

      fetchAllPatientMetadata(patient.PatientID, availableServers).then();

      const OHIFStudyMetadata = new metadata.OHIFStudyMetadata(earliestStudy, earliestStudy.StudyInstanceUID);
      updateStudyDisplaySets(earliestStudy, OHIFStudyMetadata);
      updateStudyMetadataManager(earliestStudy, OHIFStudyMetadata);

      const studyMetadataWithServer = { OHIFStudyMetadata, server: pServer };
      // The first series has already been added to the study. Continue
      // retrieving metadata without holding back thumbnail and pixel-data
      // requests for the viewer.
      loadRemainingSeries(studyMetadataWithServer).catch((loadError) => {
        console.error('Unable to load the remaining study metadata.', loadError);
      });

      finished = true;
      resolve(true);
    });

  for (let i = 0; i < availableServers.length; i++) {
    let pServer = availableServers[i];
    promises.push(fetchHistoryPromise({ pServer }));
  }

  Promise.all(promises).then((values) => {
    const isError = !values.find((value) => value);
    if (isError) {
      setError('error.notFound')
    } else {
      setFetchComplete(true);
       // patch to make thumbnails calls first and then render instances. change when loader refactor is done
       setTimeout(() => {
        setRenderViewer(true);
      }, 100)
    };
  });
};
